if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
  const container = this.querySelector('[role="document"]');

  // Mobile: show all images in a vertical list
  if (window.innerWidth <= 749) {
    this.querySelectorAll('[data-media-id]').forEach((media) => {
      media.classList.add('active');
    });

    container.scrollTop = 0;
    return;
  }

  // Desktop: keep existing behavior
  this.querySelectorAll(
    `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
  ).forEach((element) => {
    element.classList.remove('active');
  });

  const activeMedia = this.querySelector(
    `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
  );

  const activeMediaTemplate = activeMedia.querySelector('template');
  const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

  activeMedia.classList.add('active');
  activeMedia.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });

  container.scrollLeft = (activeMedia.clientWidth - container.clientWidth) / 2;

  if (
    activeMedia.nodeName === 'DEFERRED-MEDIA' &&
    activeMediaContent &&
    activeMediaContent.querySelector('.js-youtube')
  ) {
    activeMedia.loadContent();
  }
}
    }
  );
}
